import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {luckyMoneys,luckyMoney,preGrab,grab,selfDetails,winnerDetails,luckyMoneyEnd,luckyMoneyWinnerExp} = api

/**
 * 查找
 */
export async function findLuckyMoneys(params) {
    return request({url: luckyMoneys, method: 'get', data: params,})
}
/**
 * 创建红包
 */
export async function createLuckyMoneys(params) {
    return request({url: luckyMoneys, method: 'post', data: params,})
}
/**
 * 关闭红包
 */
export async function endLuckyMoney(params) {
    return request({url: luckyMoneyEnd, method: 'post', data: params,})
}

/**
 * 查询红包
 */
export async function findLuckyMoney(params) {
    return request({url: luckyMoney, method: 'get', data: params,})
}
/**
 * 编辑红包
 */
export async function updateLuckyMoney(params) {
    return request({url: luckyMoney, method: 'put', data: params,})
}
/**
 * 删除红包
 */
export async function deleteLuckyMoney(params) {
    return request({url: luckyMoney, method: 'delete', data: params,})
}

/**
 * 验证抢红包资格
 */
export async function verifyPreGrab(params) {
    return request({url: preGrab+'?uniqueKey='+(params.uniqueKey ? params.uniqueKey : ''), method: 'post', data: params,})
}

/**
 * 抢红包
 */
export async function takeGrab(params) {
    return request({url: grab, method: 'post', data: params,})
}

/**
 * 查询自己的中奖详情
 */
export async function findSelfDetails(params) {
    return request({url: selfDetails, method: 'get', data: params,})
}

/**
 * 查询所有的中奖详情
 */
export async function findWinnerDetails(params) {
    return request({url: winnerDetails, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function findLuckyMoneyWinnerExp(params) {
    return request({url: luckyMoneyWinnerExp, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/luckyMoney.js